import { COMMERCIAL_CRYPTO_ASSETS_COMPONENT } from 'constants/flagBasedMBFeatures'
require('./globalPositionInvestmentsSection.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const GlobalPositionTotalBalance = require('components/globalPosition/globalPositionTotalBalance/globalPositionTotalBalance');
const GlobalPositionInvestments = require('components/globalPosition/globalPositionInvestments/globalPositionInvestments');
const LinkToPreferences = require('../shared/linkToPreferences');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('commonsComponents/OKButton');
const WebappRender = require('components/conditionalRender/webappRender')
const { LoadingSection } = require('commonsComponents/loadingSection');
import { CryptoAssetsBanner } from '../globalPositionFinancialCard/cryptoAssets/cryptoAssetsBanner';

// @constants
const { INVESTMENT } = require('constants/globalPositionBoxes');
const { OPENBANK_PRODUCT_WEALTH, OPENBANK_PRODUCT_BANKING, BROKER_PG_URL, BROKER_PG_ROBO_URL } = require('constants/index');
const { YOUR_INVESTMENTS , NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES } = require('constants/flagBasedFeatures');

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class GlobalPositionInvestmentsSection extends React.Component {

    handleMoreInfoClick() {
        const { flagBasedFeatures, history } = this.props;
        flagBasedFeatures.get(YOUR_INVESTMENTS) ? history.push(BROKER_PG_URL) : history.push(BROKER_PG_ROBO_URL);
    }

    render() {
        const {
            immWalletSummarization,
            immWealthRoboValues,
            landingBoxes,
            hasInvestments,
            isRoboEnabled,
            flagBasedFeatures,
            immFlagBasedMBFeatures,
            wealthDataFF,
            wealthErrorFF,
            isWealthDataFetching,
            isFetching,
            immCryptoContracts,
        } = this.props;
        const emptyStateSecondaryMessage = formatText('myGlobalPosition-myGlobalPosition_nonInvestmentsProducts');
        let newPGWealthFF = flagBasedFeatures.get(NOT_ALLOWED_NEW_PG_WEALTH_COUNTRIES);
        let totalFF = wealthDataFF.get('total') || 0;

        const hasCryptoAssets = wealthDataFF.get('hasCryptoAssets');
        const cryptoAssetsFF = immFlagBasedMBFeatures.get(COMMERCIAL_CRYPTO_ASSETS_COMPONENT);

        const investmentsAmounts = immWalletSummarization.getIn(['values', 'balance']).concat(
            immWalletSummarization.getIn(['futures', 'balance']),
            immWalletSummarization.getIn(['plans', 'balance']),
            immWalletSummarization.getIn(['funds', 'balance']),
            immWealthRoboValues.get('balance')
        );

        let globalPositionInvestments;
        let expanded = landingBoxes.includes(INVESTMENT);

        globalPositionInvestments = (
            <div
                className="global-position-investments-section__subsection"
                id="global-position-investments"
            >
                <GlobalPositionInvestments
                    id={INVESTMENT}
                    expanded={expanded}
                    immWalletSummarization={immWalletSummarization}
                    immWealthRoboValues={immWealthRoboValues}
                    isRoboEnabled={isRoboEnabled}
                    flagBasedFeatures={flagBasedFeatures}
                    immFlagBasedMBFeatures={immFlagBasedMBFeatures}
                    wealthDataFF={wealthDataFF}
                    immCryptoContracts={immCryptoContracts}
                    wealthErrorFF={wealthErrorFF}
                />
            </div>
        );
        const buttonElement = (
            <div className="global-position-investments-section__more-info-button">
                <OKButton modifier="primary" onClick={() => this.handleMoreInfoClick()}>
                    <FormattedText value="myGlobalPosition-myGlobalPosition_seeProductsAvailable" />
                </OKButton>
            </div>
        );

        const getInvestmentSection = () => (
            <div className="global-position-investments-section__section">
                <h3 className="global-position-investments-section__section-title">
                    <FormattedText value="myGlobalPosition-investments" />
                </h3>
                <WebappRender>
                    <div className="global-position-investments-section__link-settings hidden-xs">
                        <span className="global-position-investments-section__link-settings-text">
                            <FormattedText value="myGlobalPosition-settings" />
                        </span>
                        <LinkToPreferences />
                    </div>
                </WebappRender>
                {isWealthDataFetching || isFetching ?
                    <LoadingSection /> :
                    <React.Fragment>
                        {globalPositionInvestments}
                        <GlobalPositionTotalBalance
                            translationKey="myGlobalPosition-myGlobalPosition_totalBalanceInvestments"
                            immAmounts={newPGWealthFF && !wealthErrorFF ? totalFF :investmentsAmounts}
                            iconClass="default"
                            keepSign={true}
                            product={!__CONTACT_CENTER__ ? OPENBANK_PRODUCT_WEALTH : OPENBANK_PRODUCT_BANKING}
                        />
                        {
                            !hasCryptoAssets && !wealthErrorFF && cryptoAssetsFF && (
                                <div className="col-xs-12 global-position-investments-section__crypto-assets-container">
                                    <CryptoAssetsBanner />
                                </div>
                            )
                        }
                    </React.Fragment>
                }
            </div>
        );

        const getEmptyInvestmentSection = () => (
            <div className="global-position-investments-section__section">
                <h3 className="global-position-investments-section__section-title">
                    <FormattedText value="myGlobalPosition-investments" />
                </h3>
                <div className="global-position-investments-section__section-emptystate">
                    <i className="glb-position-financial-card-header__title-icon icon rebrand-investments"></i>
                    <FormattedText value="myGlobalPosition-myGlobalPosition_wealth" className="global-position-investments-section__section-emptystate-title" />
                    <EmptyState secondaryText={emptyStateSecondaryMessage} iconType="noinvestment-wealth" withMargin={true} button={buttonElement} />
                </div>
                {
                    !hasCryptoAssets && !wealthErrorFF && cryptoAssetsFF && (
                        <div className="col-xs-12 global-position-investments-section__crypto-assets-container">
                            <CryptoAssetsBanner />
                        </div>
                    )
                }
            </div>
        );

        const investmentSection = hasInvestments ? getInvestmentSection() : getEmptyInvestmentSection()

        return (
            <div className="global-position-investments-section">
                {investmentSection}
            </div>
        );
    }
}

GlobalPositionInvestmentsSection.propTypes = {
    history: PropTypes.object.isRequired,
    immWalletSummarization: PropTypes.object.isRequired,
    immWealthRoboValues: PropTypes.object.isRequired,
    immCryptoContracts: PropTypes.object.isRequired,
    landingBoxes: PropTypes.object.isRequired,
    hasInvestments: PropTypes.number.isRequired,
    isRoboEnabled: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    immFlagBasedMBFeatures: PropTypes.object.flagBasedMBFeatures,
    wealthDataFF: PropTypes.object,
    wealthErrorFF: PropTypes.bool,
    isWealthDataFetching:PropTypes.bool,
    isFetching:PropTypes.bool,
    errorCryptoContractList: PropTypes.bool,
};

module.exports = withFeatureToggling(withRouter(GlobalPositionInvestmentsSection));
